"use strict";

var moduleName = "form-drop-down";

module.exports = function () {
	$("body").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);



		//
		// Раскрывающаяся форма
		//

		$(".jsBtnOpenFormDropDown").on("click", function(e) {
			e.preventDefault();

			$(this).addClass("active");
			$(".jsFormDropDown").show(200);
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/formDropDownInit.js
 **/